<div id="vEventAttendees" style="margin-top: 3rem;">
    <app-header title=""></app-header>
    <div class="row">                    
        <div class="col text-left">                        
            <div id="virtualEventReportName" class="px-4 pb-0 pt-3 paybee-modal-header--regular-important headline-4" style="border-bottom: none!important;">Event Name</div>
            <ul class="nav nav-tabs md-tabs md-tabs--paybee paybee-modal-header--regular-important px-4 pb-0 pt-5">                            
                <li class="nav-item nav-item-important">
                    <a class="nav-link nav-link-important" data-toggle="tab" href="#panelVEventAtAGlace" role="tab">At A Glance</a>
                </li>
                <li class="nav-item nav-item-important">
                    <a class="nav-link nav-link-important active" data-toggle="tab" href="#panelAttendees" role="tab">Attendees</a>
                </li>
                <li class="nav-item nav-item-important">
                    <a id="panelInvitationsTab" class="nav-link nav-link-important" data-toggle="tab" href="#panelInvitations" role="tab">Invitations</a>
                </li>
                <li class="nav-item nav-item-important">
                    <a id="panelEventPageInvitationsTab" class="nav-link nav-link-important" data-toggle="tab" href="#panelEventPageInvitations" role="tab">Event Page Invitations</a>
                </li>
                <li class="nav-item nav-item-important">
                    <a (click)="showRemindersPage()" id="panelVirtualRemindersTab" class="nav-link nav-link-important" data-toggle="tab" href="#panelVirtualReminders" role="tab">Reminders</a>
                </li>
            </ul>

            <div class="tab-content tab-content-important">
                <div class="tab-pane fade" id="panelVEventAtAGlace" role="tabpanel">
                    <div class="d-flex">
                        <div class="d-block w-100">
                            <div class="ticket-summary__holder headline-5 mb-2 mt-2">At A Glance</div>
                            <div class="ticket-summary__type body-2 grey-text mb-4" id="vEventNameReport">Event totals and distribution by campaign.</div>
                        </div>
                    </div>
                    <div id="vEventSummaryDiv" style="padding: 0 1rem 0 1rem">
                        <div class="row text-left eventSummaryRow pl-2" style="padding-top: 0px;padding-bottom: 0px;">
                            <div class="col eventSummary" style="border: none;font-size: x-small;padding-top: 0px;padding-bottom: 0px;">
                                <small class="muted">Last Updated: </small>
                                <small class="muted" id="lastVActivityUpdated"></small>
                            </div>
                        </div>
                        <div class="row text-center eventSummaryRow" style="padding-top: 0px;">
                            <div class="col-6" style="border: none">
                                <div class="row text-center">
                                    <div class="col d-flex">
                                        <a id="refreshVActivity" class="blue-text" onclick="" style="line-height: 33px;"><i class="fas fa-sync"></i></a>
                                    </div>
                                </div>
                                <div class="row text-center">
                                    <div class="col">
                                        <H3>Total</H3>
                                        <H1 id="vEventSummaryTotal"></H1>
                                    </div>
                                </div>
                                <div class="row text-center eventSummaryRow">
                                    <div class="col">
                                        <span>Pending</span><br/>
                                        <span id="vEventSummaryPending"></span>
                                    </div>
                                    <div class="col" style="border: none">
                                        <span>Donated</span><br/>
                                        <span id="vEventSummaryDonated"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 text-center" id="pieChartVEventSummaryCol">
                                <canvas class="text-center" id="pieChartVEventSummary"></canvas>
                            </div>
                        </div>
                        <div class="row justify-content-center" style="margin-top: 1rem">
                            <div class="col text-center" id="barChartVEventCampaignsCol" style="border-right: 1px solid #00000026;">
                                <canvas class="text-center" id="barChartVEventCampaigns"></canvas>
                            </div>
                        </div>
                        <div class="container">
                            <div class="row justify-content-center">
                                <div class="col">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="row justify-content-center" id="vEventCampaignDetailRow">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center" style="margin-top: 1rem">
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade in show active" id="panelAttendees" role="tabpanel">
                    <div class="col-12">
                        <div class="d-flex">
                            <div class="d-block w-100">
                                <div class="ticket-summary__holder headline-5 mb-2 mt-2">Attendees <a id="refreshVirtualAttendees" class="blue-text ticket-summary__type" onclick=""><i class="fas fa-sync"></i></a></div>
                                <div class="ticket-summary__type body-2 grey-text">List of attendees</div>
                            </div>
                            <div class="d-block">
                                <div class="d-flex w-100">
                                    <div>
                                        <button id="addVirtualEventAttendee" type="button" class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap" aria-expanded="false"><i class="fa fa-user-plus mr-2"></i>Add Attendees...</button>
                                    </div>
                                    <div>
                                        <button type="button" data-toggle="dropdown" class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap" aria-expanded="false">
                                            <i class="fas fa-paper-plane mr-2"></i>
                                            <span class="mr-2">Reminders</span>
                                            <i class="fas fa-caret-down"></i>
                                        </button>
                                        <ul class="dropdown-menu dropdown-menu-right" x-placement="bottom-end" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(1424px, 42px, 0px);">
                                            <li class="dropdown-item body-1"  id="sendVirtualEventReminderAll"><a>Join Event...</a></li>
                                            <li class="dropdown-item body-1" id="sendCartReminderAll"><a>Pending Carts...</a></li>
                                        </ul>
                                    </div>
                                    <div id="notifyAttendeesCol">
                                        <button id="notifyAttendees" type="button" class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap" aria-expanded="false"><i class="fas fa-comments mr-2"></i>Notify Attendees via Text</button>
                                    </div>
                                    <div>
                                        <button id="seeChatHistory" type="button" class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap" aria-expanded="false"><i class="fas fa-comments mr-2"></i>Chat History</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="row mx-0 mb-2 mt-4">
                            <div class="d-flex col-12 col-sm-6 col-xl-4 justify-content-center mb-2 mb-md-0 offset-xl-2">
                                <div class="d-flex align-items-center">
                                    <i class="fa fa-check mr-2 green-text"></i>
                                    <div class="body-1 text-nowrap"><span id="confirrmedVAttendeeCount">0</span> Confirmed</div>
                                </div>
                            </div>
                            <div class="d-flex col-12 col-sm-6 col-xl-4 justify-content-center mb-2 mb-md-0">
                                <div class="d-flex align-items-center">
                                    <i class="fas fa-eye mr-2 blue-text"></i>
                                    <div class="body-1 text-nowrap"><span id="attendedVAttendeeCount">0</span> Attended</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class='text-center no-data-text' style="display: none" id="emptyVirtualAttendeeList">No attendees yet.</div>
                    <div class="table--paybee">
                        <table id ="virtualAttendeeList" class="table" cellspacing="0" style="width: 100%;">
                            <thead class="thead-light">
                            <tr>
                                <th>Name</th>
                                <th>Email</th>                                            
                                <th>Live</th>
                                <th>Attended</th>
                                <th class="no-export" style='white-space: nowrap;'>Cart</th>
                                <th>Pending</th>
                                <th>Donated</th>
                                <th>Created</th>
                                <th>Address</th>
                                <th>Phone</th>
                                <th>Info</th>
                                <th style='white-space: nowrap;'>Checkout Link</th>
                                <th style='white-space: nowrap;'>Join Link</th>
                                <th class="no-export">Actions</th>
                            </tr>
                            </thead>
                        </table>
                    </div>
                </div>
                <div class="tab-pane fade" id="panelInvitations" role="tabpanel">
                    <div class="row">
                        <div class="col-12">
                            <div class="d-flex">
                                <div class="d-block w-100">
                                    <div class="ticket-summary__holder headline-5 mb-2 mt-2">Invitations</div>
                                    <div class="ticket-summary__type body-2 grey-text" id="vEventNameReportInvitations">Invitations for direct RSVP for virtual event.</div>
                                </div>
                                <div class="d-block">
                                    <div class="d-flex w-100">
                                        <div>
                                            <button id="sendNewVEventInvites" type="button" class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap" aria-expanded="false"><i class="fa fa-user-plus mr-2"></i>Invite...</button>
                                        </div>
                                        <div>
                                            <button type="button" data-toggle="dropdown" class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap">
                                                <i class="fas fa-paper-plane mr-2"></i>
                                                <span class="mr-2">Reminders</span>
                                                <i class="fas fa-caret-down"></i>
                                            </button>
                                            <ul class="dropdown-menu dropdown-menu-right">
                                                <li class="dropdown-item body-1" id="remindVEventPendingInvitees"><a>Reminder...</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div class="row mx-0 mb-2 mt-4">
                            <div class="d-flex col-12 col-sm-6 col-md-4 col-xl-2 justify-content-center mb-2 mb-xl-0 offset-xl-1">
                                <div class="d-flex align-items-center">
                                    <i class="fas fa-paper-plane mr-2"></i>
                                    <div class="body-1 text-nowrap"><span id="vInviteSent">0</span> Sent</div>
                                </div>
                            </div>
                            <div class="d-flex col-12 col-sm-6 col-md-4 col-xl-2 justify-content-center mb-2 mb-xl-0">
                                <div class="d-flex align-items-center">
                                    <i class="fas fa-eye mr-2"></i>
                                    <div class="body-1 text-nowrap"><span id="vInviteOpened">0</span> Opened</div>
                                </div>
                            </div>
                            <div class="d-flex col-12 col-sm-6 col-md-4 col-xl-2 justify-content-center mb-2 mb-xl-0">
                                <div class="d-flex align-items-center">
                                    <i class="fas fa-check-circle mr-2 green-text"></i>
                                    <div class="body-1 text-nowrap"><span id="vInviteAccepted">0</span> Accepted</div>
                                </div>
                            </div>
                            <div class="d-flex col-12 col-sm-6 col-md-6 col-xl-2 justify-content-center mb-2 mb-xl-0">
                                <div class="d-flex align-items-center">
                                    <i class="fas fa-ban mr-2 red-text"></i>
                                    <div class="body-1 text-nowrap"><span id="vInviteDeclined">0</span> Declined</div>
                                </div>
                            </div>
                            <div class="d-flex col-12 col-sm-12 col-md-6 col-xl-2 justify-content-center mb-2 mb-xl-0">
                                <div class="d-flex align-items-center">
                                    <i class="fas fa-question mr-2 red-text"></i>
                                    <div class="body-1 text-nowrap"><span id="vInviteBounced">0</span> Bounced</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="table--paybee">
                        <div class='text-center no-data-text' style="display: none" id="emptyVInviteList">No invitations yet.</div>
                        <table id="vInviteInviteList" class="table" cellspacing="0" style="width: 100%;">
                            <thead class="thead-light">
                                <tr>
                                    <th class="no-export">Actions</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Updated</th>
                                    <th>Status</th>
                                    <th>Reminded</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
                <div class="tab-pane fade" id="panelEventPageInvitations" role="tabpanel">
                    <div class="d-flex">
                        <div class="d-block w-100">
                            <div class="ticket-summary__holder headline-5 mb-2 mt-2">Event Page Invitations
                                <a id="refreshVEventPage" onclick="" class="blue-text ticket-summary__type">
                                    <i class="fas fa-sync"></i>
                                </a>
                            </div>
                            <div class="ticket-summary__type body-2 grey-text" id="vEventNameReport">Invitations for the registartion through event page.</div>
                        </div>
                        <div class="d-block">
                            <div class="d-flex w-100">
                                <div>
                                    <button id="sendNewEventPageInvites" type="button" class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap" aria-expanded="false"><i class="fa fa-user-plus mr-2"></i>Invite...</button>
                                </div>
                                <div>
                                    <button type="button" data-toggle="dropdown" class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap">
                                        <i class="fas fa-paper-plane mr-2"></i>
                                        <span class="mr-2">Reminders</span>
                                        <i class="fas fa-caret-down"></i>
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-right">
                                        <li class="dropdown-item body-1" id="remindEventPageInvitees"><a>Reminder...</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="eventPageInvitationStatistic">
                        <div class="row mx-0 mb-2 mt-4 justify-content-center">
                            <div class="d-flex col-12 col-sm-6 col-md-4 col-xl-3 justify-content-center mb-2 mb-md-0">
                                <div class="d-flex align-items-center">
                                    <i class="fas fa-paper-plane mr-2"></i>
                                    <div class="body-1 text-nowrap"><span id="eventPageInvitationStatisticSent">0</span> Sent</div>
                                </div>
                            </div>
                            <div class="d-flex col-12 col-sm-6 col-md-4 col-xl-3 justify-content-center mb-2 mb-md-0">
                                <div class="d-flex align-items-center">
                                    <i class="fas fa-eye mr-2"></i>
                                    <div class="body-1 text-nowrap"><span id="eventPageInvitationStatisticOpened">0</span> Opened</div>
                                </div>
                            </div>
                            <div class="d-flex col-12 col-sm-12 col-md-4 col-xl-3 justify-content-center mb-2 mb-md-0">
                                <div class="d-flex align-items-center">
                                    <i class="fas fa-question mr-2 red-text"></i>
                                    <div class="body-1 text-nowrap"><span id="eventPageInvitationStatisticBounced">0</span> Bounced</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="table--paybee">
                        <div class='text-center no-data-text' style="display: none" id="emptyVEventPageInviteList">No invitations yet.</div>
                        <table id="vEventPageInviteList" class="table" cellspacing="0" style="width: 100%;">
                            <thead class="thead-light">
                                <tr>
                                    <th class="no-export">Actions</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Updated</th>
                                    <th>Status</th>
                                    <th>Reminded</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
                <div class="tab-pane fade" id="panelVirtualReminders" role="tabpanel" data-page="scheduleReminder">
                    <div class="accordion md-accordion" id="scheduleReminderAccordion" style="border:none !important;" role="tablist" aria-multiselectable="true">
    
                        <div class="d-flex align-items-center justify-content-between mb-3">
                            <div class="headline-4 px-3">Reminders</div>
                            <div class="d-flex align-items-center">
                                <div id="eventDateTime" class="body-1 mr-2"></div>
                                <button type="button" data-toggle="dropdown" class="btn btn--paybee btn--outline-transparent btn--padding10x15 button btn--solid-border waves-effect waves-light my-0 ml-0 mr-2 shadow-none">
                                    <i class="fas fa-paper-plane mr-2"></i>
                                    <span class="mr-2">Schedule Reminder</span>
                                    <i class="fas fa-caret-down"></i>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-right">
                                    <li data-id="scheduleCustomReminder_3" data-task-type="3" data-action="scheduleCustomReminder" class="dropdown-item body-1">
                                        <a>Pending Carts Reminder...</a>
                                    </li>
                                    <li data-id="scheduleCustomReminder_6" data-task-type="6" data-action="scheduleCustomReminder" class="dropdown-item body-1">
                                        <a>Join Reminder...</a>
                                        <div data-id="scheduleCustomReminder_6_error" class="caption red-text">Event date is in the past</div>
                                    </li>
                                    <li data-id="scheduleCustomReminder_11" data-task-type="11" data-action="scheduleCustomReminder" class="dropdown-item body-1">
                                        <a>Virtual Event Invite Reminder...</a>
                                        <div data-id="scheduleCustomReminder_11_error" class="caption red-text">Event date is in the past</div>
                                    </li>
                                    <li data-id="scheduleCustomReminder_10" data-task-type="10" data-action="scheduleCustomReminder" class="dropdown-item body-1">
                                        <a>Event Page Invite Reminder...</a>
                                        <div data-id="scheduleCustomReminder_10_error" class="caption red-text">Event date is in the past</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
    
                        <div class="card" data-section="suggestedReminderCard">
                            <div class="card-header px-1" role="tab" id="suggestedReminderHeading" data-section="suggestedReminderHeading">
                                <a id="suggestedReminderHeadingLink" class="accordion-button--scheduller collapsed" data-toggle="collapse" href="#suggestedReminderCollapse" aria-expanded="false" aria-controls="suggestedReminderCollapse">
                                    <span class="headline-6 black-text pl-5 mb-2">Suggested</span>
                                </a>
                            </div>
    
                            <div id="suggestedReminderCollapse" class="collapse" role="tabpanel" aria-labelledby="suggestedReminderHeading">
                                <div class="card-body pt-0 px-0">
                                    <div class="col-12 col-xl-10" id="recommendationListContainer" data-section="suggestedReminderListContainer"></div>
                                </div>
                            </div>
                        </div>
    
                        <div class="card" data-section="scheduledReminderCard">
                            <div class="card-header px-1" role="tab" id="scheduledReminderHeading" data-section="scheduledReminderHeading">
                                <a id="scheduledReminderHeadingLink" class="accordion-button--scheduller collapsed" data-toggle="collapse" href="#scheduledReminderCollapse" aria-expanded="false" aria-controls="scheduledReminderCollapse">
                                    <span class="headline-6 black-text pl-5 mb-2">Scheduled</span>
                                </a>
                            </div>
    
                            <div id="scheduledReminderCollapse" class="collapse" role="tabpanel" aria-labelledby="scheduledReminderHeading">
                                <div class="card-body pt-0 px-0">
                                    <div class="col-12 col-xl-10" id="scheduledListContainer" data-section='scheduledReminderListContainer'></div>
                                </div>
                            </div>
                        </div>
    
                        <div class="card" data-section="completedReminderCard">
                            <div class="card-header px-1" role="tab" id="completedReminderHeading" data-section="completedReminderHeading">
                                <a id="completedReminderHeadingLink" class="accordion-button--scheduller collapsed" data-toggle="collapse" href="#completedReminderCollapse" aria-expanded="false" aria-controls="completedReminderCollapse">
                                    <span class="headline-6 black-text pl-5 mb-2">Completed</span>
                                </a>
                            </div>
    
                            <div id="completedReminderCollapse" class="collapse" role="tabpanel" aria-labelledby="completedReminderHeading">
                                <div class="card-body pt-0 px-0">
                                    <div class="col-12 col-xl-10" id="completedListContainer" data-section='completedReminderListContainer'></div>
                                </div>
                            </div>
                        </div>
    
                        <div class="card" data-section="cancelledReminderCard">
                            <div class="card-header px-1" role="tab" id="cancelledReminderHeading" data-section="cancelledReminderHeading">
                                <a id="cancelledReminderHeadingLink" class="accordion-button--scheduller collapsed" data-toggle="collapse" href="#cancelledReminderCollapse" aria-expanded="false" aria-controls="cancelledReminderCollapse">
                                    <span class="headline-6 black-text pl-5 mb-2">Cancelled</span>
                                </a>
                            </div>
    
                            <div id="cancelledReminderCollapse" class="collapse" role="tabpanel" aria-labelledby="cancelledReminderHeading">
                                <div class="card-body pt-0 px-0">
                                    <div class="col-12 col-xl-10" id="cancelledListContainer" data-section='cancelledReminderListContainer'></div>
                                </div>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
